import React from 'react';
import { FormGroup, Label, Input } from '../../../styles/components';

interface CredentialsStepProps {
  username: string;
  password: string;
  onUsernameChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  providerName?: string;
}

export function CredentialsStep({ 
  username, 
  password, 
  onUsernameChange, 
  onPasswordChange,
  providerName 
}: CredentialsStepProps) {
  return (
    <>
      <div style={{ 
        marginBottom: '1rem', 
        padding: '1rem', 
        backgroundColor: '#f3f4f6', 
        borderRadius: '0.5rem' 
      }}>
        <p style={{ margin: 0, color: '#374151', fontSize: '0.875rem' }}>
          Enter the credentials for connecting to {providerName || 'the provider'}.
        </p>
      </div>
      <FormGroup>
        <Label htmlFor="username">Username *</Label>
        <Input
          id="username"
          value={username}
          onChange={(e) => onUsernameChange(e.target.value)}
          placeholder="Enter username"
        />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="password">Password *</Label>
        <Input
          id="password"
          type="password"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          placeholder="Enter password"
        />
      </FormGroup>
    </>
  );
}